import { HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, Injectable } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';

import { NgbModule, NgbDateParserFormatter, NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { NotifierModule } from 'angular-notifier';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { LoginComponent } from './core/components/login/login.component';
import { AppTranslationModule } from './app.translation.module';
import { HomeComponent } from './core/components/home/home.component';
import { SettingsComponent } from './core/components/settings/settings.component';
import { HeaderComponent } from './core/components/header/header.component';
import { Residence } from './core/models/residence';
import { NgbDateCustomParserFormatter } from './core/globals/ngb-date-custom-parser-formatter';
import { SharedModule } from './shared/shared.module';
import { customNotifierOptions } from '@core/globals/notifier.options';

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
	overrides = {
		pinch: { enable: false },
		rotate: { enable: false }
	};
}

@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		HomeComponent,
		SettingsComponent,
		HeaderComponent,
	],
	imports: [
		BrowserModule,
		RouterModule,
		SharedModule,
		AppRoutingModule,
		ReactiveFormsModule,
		AppTranslationModule,
		BrowserAnimationsModule,
		NgxMatSelectSearchModule,
		FormsModule,
		OktaAuthModule,
		NgbModule,
		HammerModule,
		NgHttpLoaderModule.forRoot(),
		NotifierModule.withConfig(customNotifierOptions),		
	],
	exports: [
		RouterModule,
		HttpClientModule
	],
	providers: [
		DatePipe,
		{
			provide: HAMMER_GESTURE_CONFIG,
			useClass: MyHammerConfig
		},
		{
			provide: NgbDateParserFormatter,
			useClass: NgbDateCustomParserFormatter
		},
		{
			provide: NgbDateAdapter,
			useClass: NgbDateNativeAdapter
		},
		{
			provide: OKTA_CONFIG,
			useValue: {
				issuer: 'https://login-dev.asnportal.nl/login-dev.asnportal.nl/oauth2/v2.0',
				redirectUri: `${window.location.origin}/implicit/callback`,
				clientId: 'a890ebcc-c7de-46b9-b7ff-ce47bfedae7a',
				scopes: ['openid', 'profile', 'https://login-dev.asnportal.nl/genericapi/ReadWrite.All'],
				responseType: ['token'],
				authorizeUrl: 'https://login-dev.asnportal.nl/login-dev.asnportal.nl/b2c_1a_signin/oauth2/v2.0/authorize',
				tokenUrl: 'https:/login-dev.asnportal.nl/login-dev.asnportal.nl/b2c_1a_signin/oauth2/v2.0/token',
				userInfoUrl: 'https://login-dev.asnportal.nl/login-dev.asnportal.nl/b2c_1a_signin/oauth2/v2.0/userInfo',
				pkce: false
			}
			// Settings will be replaced in de main.js by Azure DevOps release pipeline
		}

	],
	bootstrap: [AppComponent]
})
export class AppModule {
	private residences: Residence[];
	private residence: Residence;

	constructor() {
		this.residence = new Residence();
	}
}

// platformBrowserDynamic().bootstrapModule(AppModule);
